import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../../api/api";

export const fetchPdf = createAsyncThunk(
	"pdf/fetchPdf",
	async ({ examinationCode, qpCode }, { rejectWithValue }) => {
		try {
			const response = await api.get(
				`/v1/QuestionPaper/${examinationCode}/${qpCode}/PDF`,
			);
			const base64Data = response.data.data;
			const byteCharacters = atob(base64Data);
			const byteArray = new Uint8Array(byteCharacters.length);
			for (let i = 0; i < byteCharacters.length; i++) {
				byteArray[i] = byteCharacters.charCodeAt(i);
			}
			const blob = new Blob([byteArray], { type: "application/pdf" });
			return URL.createObjectURL(blob);
		} catch (error) {
			return rejectWithValue(error.message);
		}
	},
);

const QuestionPaperPdfSlice = createSlice({
	name: "QuestionPaperPdfSlice",
	initialState: {
		pdfUrl: "",
		loading: false,
		error: null,
		currentRequestId: null,
	},
	reducers: {
		clearQuestionPaperPdf(state) {
			state.pdfUrl = "";
			state.loading = false;
			state.error = null;
			state.currentRequestId = null;
		},
	},
	extraReducers: (builder) => {
		builder
			.addCase(fetchPdf.pending, (state, action) => {
				state.loading = true;
				state.error = null;
				state.pdfUrl = "";
				state.currentRequestId = action.meta.requestId;
			})
			.addCase(fetchPdf.fulfilled, (state, action) => {
				if (state.currentRequestId !== action.meta.requestId) return;
				state.loading = false;
				state.pdfUrl = action.payload;
				state.currentRequestId = null;
			})
			.addCase(fetchPdf.rejected, (state, action) => {
				if (state.currentRequestId !== action.meta.requestId) return;
				state.loading = false;
				state.error = action.payload;
				state.pdfUrl = "";
				state.currentRequestId = null;
			});
	},
});

export const { clearQuestionPaperPdf } = QuestionPaperPdfSlice.actions;
export default QuestionPaperPdfSlice.reducer;
